<template>
  <GiftWrapping
    v-if="!cartItemCount"
    :value="giftWrappingComment"
    @update="e => (giftWrappingComment = e)"
    @add="e => (giftWrappingComment = e)"
    @remove="e => (giftWrappingComment = e)"
  />
  <div v-else>
    <CartItemGiftWrapping
      v-if="item.giftBoxOptionId || item.giftBoxMessage"
      :gift-box-message="item.giftBoxMessage"
      :item-id="item.id"
      :option-id="item.giftBoxOptionId"
    />
  </div>
</template>
<script setup lang="ts">
const { product } = useProductContext();
const { giftWrappingComment } = useProductGiftWrappingContext();
const { cartItemCount, item } = useCartItemCount(computed(() => product?.value?.sku || ''));
</script>
